/* ==========================================================
   COMPLEMENTARY PRODUCTS — SCROLL CUSTOM
   Le contenu du bloc "Recommandé pour vous" est chargé en
   AJAX par le composant <product-recommendations>, donc ce
   script attend son apparition via MutationObserver avant
   d'initialiser la barre de progression (curseur draggable),
   les flèches et le drag-to-scroll des produits.
   ========================================================== */

function initComplementaryNav(container) {
  if (container.dataset.lmNavInit) return;
  container.dataset.lmNavInit = 'true';

  const scroller = container.querySelector('.complementary-slide > ul');
  if (!scroller) return;

  const nav = document.createElement('div');
  nav.className = 'lm-comp-nav';
  nav.innerHTML = `
    <div class="lm-comp-progress-track">
      <div class="lm-comp-progress-bar"></div>
    </div>
    <div class="lm-comp-arrows">
      <button type="button" class="lm-comp-arrow lm-comp-arrow--prev" aria-label="Précédent">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <button type="button" class="lm-comp-arrow lm-comp-arrow--next" aria-label="Suivant">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  `;
  container.appendChild(nav);

  const track = nav.querySelector('.lm-comp-progress-track');
  const progressBar = nav.querySelector('.lm-comp-progress-bar');
  const prevBtn = nav.querySelector('.lm-comp-arrow--prev');
  const nextBtn = nav.querySelector('.lm-comp-arrow--next');

  const BAR_WIDTH_PERCENT = 30; // doit correspondre au CSS (.lm-comp-progress-bar width)

  function getMaxScroll() {
    return scroller.scrollWidth - scroller.clientWidth;
  }

  function updateProgress() {
    const maxScroll = getMaxScroll();
    const percent = maxScroll > 0 ? (scroller.scrollLeft / maxScroll) * 100 : 0;
    const maxLeft = 100 - BAR_WIDTH_PERCENT;
    progressBar.style.left = (percent / 100) * maxLeft + '%';

    prevBtn.disabled = scroller.scrollLeft <= 5;
    nextBtn.disabled = scroller.scrollLeft >= maxScroll - 5;
  }

  scroller.addEventListener('scroll', updateProgress);
  window.addEventListener('load', updateProgress);
  setTimeout(updateProgress, 500);
  updateProgress();

  // --- Flèches : défile d'une carte à la fois ---
  function scrollByCard(direction) {
    const card = scroller.querySelector('li');
    if (!card) return;
    const cardWidth = card.getBoundingClientRect().width;
    const gap = parseInt(getComputedStyle(scroller).gap) || 0;
    scroller.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
  }

  prevBtn.addEventListener('click', function () { scrollByCard(-1); });
  nextBtn.addEventListener('click', function () { scrollByCard(1); });

  // --- Drag-to-scroll sur les cartes produits (souris) ---
  let isDown = false;
  let startX;
  let scrollLeftStart;

  scroller.addEventListener('mousedown', function (e) {
    isDown = true;
    scroller.classList.add('lm-dragging');
    startX = e.pageX - scroller.offsetLeft;
    scrollLeftStart = scroller.scrollLeft;
  });

  scroller.addEventListener('mouseleave', function () {
    isDown = false;
    scroller.classList.remove('lm-dragging');
  });

  scroller.addEventListener('mouseup', function () {
    isDown = false;
    scroller.classList.remove('lm-dragging');
  });

  scroller.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - scroller.offsetLeft;
    const walk = (x - startX) * 1.2;
    scroller.scrollLeft = scrollLeftStart - walk;
  });

  // --- Drag du curseur de la barre de progression ---
  let isDraggingBar = false;

  function setScrollFromBarPosition(clientX) {
    const trackRect = track.getBoundingClientRect();
    const barWidthPx = (BAR_WIDTH_PERCENT / 100) * trackRect.width;
    const usableWidth = trackRect.width - barWidthPx;

    let relativeX = clientX - trackRect.left - barWidthPx / 2;
    relativeX = Math.max(0, Math.min(relativeX, usableWidth));

    const percent = usableWidth > 0 ? relativeX / usableWidth : 0;
    const maxScroll = getMaxScroll();
    scroller.scrollLeft = percent * maxScroll;
  }

progressBar.addEventListener('mousedown', function (e) {
  isDraggingBar = true;
  progressBar.classList.add('lm-dragging-bar');
  scroller.style.scrollSnapType = 'none'; // désactive le snap pendant le drag
  e.preventDefault();
});

document.addEventListener('mousemove', function (e) {
  if (!isDraggingBar) return;
  setScrollFromBarPosition(e.clientX);
});

document.addEventListener('mouseup', function () {
  if (!isDraggingBar) return;
  isDraggingBar = false;
  progressBar.classList.remove('lm-dragging-bar');
  scroller.style.scrollSnapType = ''; // réactive le snap une fois le drag terminé
});


  // Permet aussi de cliquer directement sur la piste pour sauter à cet endroit
  track.addEventListener('mousedown', function (e) {
    if (e.target === progressBar) return; // déjà géré ci-dessus
    setScrollFromBarPosition(e.clientX);
  });
}

function scanForComplementaryBlocks() {
  document.querySelectorAll('.complementary-products__container').forEach(initComplementaryNav);
}

scanForComplementaryBlocks();

const lmObserver = new MutationObserver(function () {
  scanForComplementaryBlocks();
});

lmObserver.observe(document.body, { childList: true, subtree: true });